import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function BulletedIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M5.66821 7.01404C5.66821 7.97321 5.03186 8.75 4.00244 8.75C2.97302 8.75 2.33203 7.97321 2.33203 7.01404C2.33203 6.02667 2.97302 5.25 4.00244 5.25C5.03186 5.25 5.66821 6.02667 5.66821 7.01404Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M4.00244 15.25C2.97302 15.25 2.33203 16.0267 2.33203 17.014C2.33203 17.9732 2.97302 18.75 4.00244 18.75C5.03186 18.75 5.66821 17.9732 5.66821 17.014C5.66821 16.0267 5.03186 15.25 4.00244 15.25Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M7.66821 7.99837V6H22V7.99837H7.66821Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M22 18H7.66821L7.66822 16.0016H22V18Z",
    fill: "currentColor"
  }));
}